import React from 'react';

import pages from 'pages';

import RouterProvider from 'components/RouterProvider/RouterProvider';
import SignIn from 'pages/sign-in/SignIn';
import Projects from 'components/Projects/Projects';
import ProjectReview from 'components/Project/BriefingReview/ProjectReview';
import ProjectCollectData from 'components/Project/CollectData/ProjectCollectData';
import SettingsProfile from 'components/Settings/Profile';
import SettingsEmail from 'components/Settings/Email';
import SettingsPassword from 'components/Settings/Password';
import SettingsOrganization from 'components/Settings/Organization';
import SettingsBexio from 'components/Settings/Bexio';
import RemindPassword from 'components/RemindPassword/RemindPassword';
import PasswordReset from 'components/PasswordReset/PasswordReset';
import EmailConfirm from 'components/EmailConfirm/EmailConfirm';
import Logout from 'components/Logout/Logout';
import CreateProject from 'components/CreateProject/CreateProject';
import TemplatesCreator from 'components/Templates/TemplatesCreator';
import ProjectInviteRespondents from 'components/Project/CollectData/ManualDataCollection/ProjectInviteRespondents';
import ProjectSendInvitations from 'components/Project/CollectData/ManualDataCollection/ProjectSendInvitations';
// TODO commented out as we switch to CustomerSatisfaction for now
import ProjectReports from 'components/Project/Reports/ProjectReports';
import BriefingsCreator from 'components/Templates/BriefingsCreator';
import { withTracker } from 'components/withTracker/withTracker';
import SignUp from 'pages/sign-up/SignUp';
import Payments from 'components/Payments/Payments';
import OrderHistory from 'components/Payments/OrderHistory';
import FailedPayment from 'components/Payments/FailedPayment';
import CreditCardInfo from 'components/Payments/CreditCard';
import Invoice from 'components/Payments/Invoice';
import EmailDataCollection from 'components/Project/CollectData/ManualDataCollection/EmailDataCollection';
import CSVDataCollection from 'components/Project/CollectData/ManualDataCollection/CSVDataCollection';
import LinkDataCollection from 'components/Project/CollectData/ManualDataCollection/LinkDataCollection';
import AutomaticDataCollect from 'components/Project/CollectData/AutomaticDataCollection/AutomaticDataCollect';
import ProjectStatistics from 'components/Project/Progress/Statistics';
import ProjectFiles from 'components/Project/Files/Files';
import BexioLogin from 'pages/bexio/login';
import Subscriptions from 'components/Project/Subscriptions/Subscriptions';
import EmailTemplates from 'components/Project/EmailTemplates/EmailTemplates';
import EmailTemplateEditor from 'components/Project/EmailTemplates/TemplateCreator';
import OrganizationUsers from 'pages/OrganizationAdmin/Users';
import OrganizationUserGroups from 'pages/OrganizationAdmin/Groups';
import { history } from 'consts/routing';
import OrganizationGroupShared from 'pages/OrganizationAdmin/GroupShared/GroupShared';
import OrganizationProjects from 'pages/OrganizationAdmin/Projects';
import OrganizationProjectShared from 'pages/OrganizationAdmin/ProjectShared/ProjectShared';
import OrganizationProducts from 'pages/OrganizationAdmin/Products';
import OrganizationProductShared from 'pages/OrganizationAdmin/ProductsShared/ProductsShared';
import OrganizationUserShared from 'pages/OrganizationAdmin/UserShared/UserShared';
import SharedReportPrivate from 'pages/project/SharedReportPrivate';
import { SharedReportPublic } from 'pages/project/SharedReportPublic';
const {
  Switch,
  ROUTES,
  UserProtectedRoute,
  UnauthorizedRoute,
  AdminProtectedRoute,
  OrganizationAdminProtectedRoute,
  Redirect,
  Route,
} = RouterProvider;

const sharedUnauthorizedRouteConfig = {
  redirectTo: ROUTES.DASHBOARD,
};

/* eslint-disable-next-line */
//@ts-ignore
if (window.Cypress) {
  /* eslint-disable-next-line */
  //@ts-ignore
  window.testHistory = history;
}

const Routes = () => (
  <Switch>
    {/* PROJECT ROUTES */}
    <Redirect from={ROUTES.PROJECT.MAIN} to={ROUTES.PROJECT.INFO} exact />
    <UserProtectedRoute
      path={ROUTES.PROJECT.EDIT}
      component={withTracker(ProjectReview)}
    />
    <UserProtectedRoute
      exact
      path={ROUTES.PROJECT.COLLECT_DATA}
      component={withTracker(ProjectCollectData)}
    />
    <UserProtectedRoute
      exact
      path={ROUTES.PROJECT.COLLECT_DATA_EMAIL}
      component={withTracker(EmailDataCollection)}
    />
    <UserProtectedRoute
      exact
      path={ROUTES.PROJECT.COLLECT_DATA_CSV}
      component={withTracker(CSVDataCollection)}
    />
    <UserProtectedRoute
      exact
      path={ROUTES.PROJECT.COLLECT_DATA_LINK}
      component={withTracker(LinkDataCollection)}
    />
    <UserProtectedRoute
      exact
      path={ROUTES.PROJECT.COLLECT_DATA_AUTOMATIC}
      component={withTracker(AutomaticDataCollect)}
    />
    <UserProtectedRoute
      exact
      path={ROUTES.PROJECT.COLLECT_DATA_STATISTICS}
      component={withTracker(ProjectStatistics)}
    />
    <UserProtectedRoute
      exact
      path={ROUTES.PROJECT.TEMPLATE.MAIN}
      component={withTracker(EmailTemplates)}
    />
    <UserProtectedRoute
      exact
      path={ROUTES.PROJECT.TEMPLATE.CREATE_EMAIL}
      component={withTracker(EmailTemplateEditor)}
    />
    <UserProtectedRoute
      exact
      path={ROUTES.PROJECT.TEMPLATE.EDIT_EMAIL}
      component={withTracker(EmailTemplateEditor)}
    />
    <UserProtectedRoute
      exact
      path={ROUTES.PROJECT.TEMPLATE.CREATE_REMINDER}
      component={withTracker(EmailTemplateEditor)}
    />
    <UserProtectedRoute
      exact
      path={ROUTES.PROJECT.TEMPLATE.EDIT_REMINDER}
      component={withTracker(EmailTemplateEditor)}
    />
    <UserProtectedRoute
      exact
      path={ROUTES.PROJECT.FILES}
      component={withTracker(ProjectFiles)}
    />
    <UserProtectedRoute
      path={ROUTES.PROJECT.SURVEYS_INVITE}
      component={withTracker(ProjectInviteRespondents)}
    />
    <UserProtectedRoute
      path={ROUTES.PROJECT.REPORTS}
      component={withTracker(ProjectReports)}
    />
    <UserProtectedRoute
      path={ROUTES.PROJECT.SUBSCRIPTIONS}
      component={withTracker(Subscriptions)}
    />
    <AdminProtectedRoute
      path={ROUTES.PROJECT.SURVEYS_SEND_INVITES}
      component={withTracker(ProjectSendInvitations)}
    />
    {/* DASHBOARD ROUTE */}
    <UserProtectedRoute
      path={ROUTES.DASHBOARD}
      component={withTracker(Projects)}
      exact
    />
    {/* WORKBENCH ROUTES */}
    <UserProtectedRoute
      path={ROUTES.WORKBENCH.BRANDING}
      component={withTracker(pages.WipPlaceholder)}
      exact
    />
    <UserProtectedRoute
      path={ROUTES.WORKBENCH.INNOVATION}
      component={withTracker(pages.WipPlaceholder)}
      exact
    />
    <UserProtectedRoute
      path={ROUTES.WORKBENCH.EXPERIENCE}
      component={withTracker(pages.WipPlaceholder)}
      exact
    />
    {/* PROJECTS ROUTES */}
    <UserProtectedRoute
      path={ROUTES.PROJECTS.CREATE}
      component={withTracker(CreateProject)}
    />
    <UserProtectedRoute
      path={ROUTES.PROJECTS.LIST}
      component={withTracker(Projects)}
      exact
    />
    {/* NOTIFICATION ROUTES */}
    <UserProtectedRoute
      path={ROUTES.NOTIFICATIONS}
      component={withTracker(pages.WipPlaceholder)}
      exact
    />
    {/* PAYMENTS ROUTES */}
    <UserProtectedRoute
      path={ROUTES.PAYMENTS.MAIN}
      component={withTracker(Payments)}
      exact
    />
    <UserProtectedRoute
      path={ROUTES.PAYMENTS.ORDER_HISTORY}
      component={withTracker(OrderHistory)}
      exact
    />
    <UserProtectedRoute
      path={ROUTES.PAYMENTS.FAILED_PAYMENT}
      component={withTracker(FailedPayment)}
    />
    <UserProtectedRoute
      path={ROUTES.PAYMENTS.CREDIT_CARD_INFO}
      component={withTracker(CreditCardInfo)}
      exact
    />
    <UserProtectedRoute
      path={ROUTES.PAYMENTS.INVOICE_INFO}
      component={withTracker(Invoice)}
      exact
    />
    <Redirect
      from={ROUTES.PAYMENTS.SUCCESS_PAYMENT}
      to={`${ROUTES.PAYMENTS.MAIN}?payment=success`}
    />
    {/* ORGANIZATION ADMIN  */}
    <OrganizationAdminProtectedRoute
      path={ROUTES.ORGANIZATION.ADMIN.USERS}
      component={OrganizationUsers}
      exact
    />
    <OrganizationAdminProtectedRoute
      path={ROUTES.ORGANIZATION.ADMIN.GROUPS}
      component={OrganizationUserGroups}
      exact
    />

    <OrganizationAdminProtectedRoute
      path={ROUTES.ORGANIZATION.ADMIN.USER_SHARED}
      component={OrganizationUserShared}
      exact
    />
    <OrganizationAdminProtectedRoute
      path={ROUTES.ORGANIZATION.ADMIN.GROUP_SHARED}
      component={OrganizationGroupShared}
      exact
    />

    <OrganizationAdminProtectedRoute
      path={ROUTES.ORGANIZATION.ADMIN.PROJECT_SHARED}
      component={OrganizationProjectShared}
      exact
    />
    <OrganizationAdminProtectedRoute
      path={ROUTES.ORGANIZATION.ADMIN.PRODUCTS_SHARED}
      component={OrganizationProductShared}
      exact
    />

    <OrganizationAdminProtectedRoute
      path={ROUTES.ORGANIZATION.ADMIN.PROJECTS}
      component={OrganizationProjects}
      exact
    />
    <OrganizationAdminProtectedRoute
      path={ROUTES.ORGANIZATION.ADMIN.PRODUCTS}
      component={OrganizationProducts}
      exact
    />
    {/* SETTINGS ROUTES */}
    <Redirect from={ROUTES.SETTINGS.MAIN} to={ROUTES.SETTINGS.PROFILE} exact />
    <Route path={ROUTES.CONFIRM_EMAIL} component={withTracker(EmailConfirm)} />
    <Route path={ROUTES.SIGN_OUT} component={withTracker(Logout)} />
    <UserProtectedRoute
      path={ROUTES.SETTINGS.PROFILE}
      component={withTracker(SettingsProfile)}
    />
    <UserProtectedRoute
      path={ROUTES.SETTINGS.EMAIL}
      component={withTracker(SettingsEmail)}
    />
    <UserProtectedRoute
      path={ROUTES.SETTINGS.PASSWORD}
      component={withTracker(SettingsPassword)}
    />
    <UserProtectedRoute
      path={ROUTES.SETTINGS.ORGANIZATION}
      component={withTracker(SettingsOrganization)}
    />
    <UserProtectedRoute
      path={ROUTES.SETTINGS.BEXIO}
      component={withTracker(SettingsBexio)}
    />
    {/* ORGANIZATION ROUTES */}
    <OrganizationAdminProtectedRoute
      exact
      path={ROUTES.ORGANIZATION.INVITE_USER}
      component={withTracker(pages.OrganizationUsersInvite)}
    />
    {/* DEEPTRUE ADMIN ROUTES */}
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.ORGANIZATIONS.LIST}
      component={pages.OrganizationsList}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.ORGANIZATIONS.PROJECTS}
      component={pages.OrganizationProjects}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.ORGANIZATIONS.USERS}
      component={pages.OrganizationUsers}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.ORGANIZATIONS.INVITATIONS_USER}
      component={pages.OrganizationUsersInvitations}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.ORGANIZATIONS.INVITE_USER}
      component={pages.OrganizationUsersInvite}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.ORGANIZATIONS.CREDITS}
      component={pages.OrganizationCredits}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.ORGANIZATIONS.PROJECT.EDIT}
      component={ProjectReview}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.ORGANIZATIONS.PROJECT.COLLECT_DATA}
      component={ProjectCollectData}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.ORGANIZATIONS.PROJECT.COLLECT_DATA_EMAIL}
      component={EmailDataCollection}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.ORGANIZATIONS.PROJECT.TEMPLATE.MAIN}
      component={EmailTemplates}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.ORGANIZATIONS.PROJECT.TEMPLATE.CREATE_EMAIL}
      component={EmailTemplateEditor}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.ORGANIZATIONS.PROJECT.TEMPLATE.CREATE_REMINDER}
      component={EmailTemplateEditor}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.ORGANIZATIONS.PROJECT.TEMPLATE.EDIT_EMAIL}
      component={EmailTemplateEditor}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.ORGANIZATIONS.PROJECT.TEMPLATE.EDIT_REMINDER}
      component={EmailTemplateEditor}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.ORGANIZATIONS.PROJECT.COLLECT_DATA_CSV}
      component={CSVDataCollection}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.ORGANIZATIONS.PROJECT.COLLECT_DATA_LINK}
      component={LinkDataCollection}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.ORGANIZATIONS.PROJECT.COLLECT_DATA_AUTOMATIC}
      component={AutomaticDataCollect}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.ORGANIZATIONS.PROJECT.COLLECT_DATA_STATISTICS}
      component={ProjectStatistics}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.ORGANIZATIONS.PROJECT.REPORTS}
      component={ProjectReports}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.ORGANIZATIONS.PROJECT.SUBSCRIPTIONS}
      component={Subscriptions}
    />
    <UserProtectedRoute
      exact
      path={ROUTES.ADMIN.ORGANIZATIONS.PROJECT.PROGRESS}
      component={withTracker(ProjectStatistics)}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.ORGANIZATIONS.PROJECT.SURVEYS_INVITE}
      component={ProjectInviteRespondents}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.ORGANIZATIONS.PROJECT.SURVEYS_SEND_INVITES}
      component={ProjectSendInvitations}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.ORGANIZATIONS.PROJECT.FILES}
      component={ProjectFiles}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.ORGANIZATIONS.USER}
      component={pages.OrganizationUser}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.TEMPLATES.SURVEYS.MAIN}
      component={pages.Templates}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.TEMPLATES.SURVEYS.CREATE}
      component={TemplatesCreator}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.TEMPLATES.SURVEYS.EDIT}
      component={TemplatesCreator}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.TEMPLATES.BRIEFINGS.MAIN}
      component={pages.BriefingTemplates}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.TEMPLATES.BRIEFINGS.CREATE}
      component={BriefingsCreator}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.TEMPLATES.BRIEFINGS.EDIT}
      component={BriefingsCreator}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.ORGANIZATIONS.SINGLE}
      component={pages.OrganizationData}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.WORKBENCHES.LIST}
      component={pages.WorkbenchesList}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.WORKBENCHES.SINGLE}
      component={pages.Workbench}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.WORKBENCHES.CREATE}
      component={pages.Workbench}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.PRODUCTS.LIST}
      component={pages.ProductsList}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.PRODUCTS.SINGLE}
      component={pages.Product}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.PRODUCTS.CREATE}
      component={pages.Product}
    />
    <AdminProtectedRoute
      exact
      path={ROUTES.ADMIN.ASSETS.LIST}
      component={pages.Assets}
    />
    {/* PRODUCTS */}
    <UserProtectedRoute
      path={ROUTES.ORGANIZATION.PRODUCTS}
      component={withTracker(pages.Briefing)}
    />
    {/* BASE ROUTES */}
    <UnauthorizedRoute
      path={ROUTES.SIGN_IN}
      component={withTracker(SignIn)}
      config={sharedUnauthorizedRouteConfig}
      exact
    />
    <UnauthorizedRoute
      path={ROUTES.SIGN_UP}
      component={withTracker(SignUp)}
      config={sharedUnauthorizedRouteConfig}
      exact
    />
    <UnauthorizedRoute
      path={ROUTES.RECOVER_PASSWORD}
      component={withTracker(RemindPassword)}
      config={sharedUnauthorizedRouteConfig}
      exact
    />
    <UnauthorizedRoute
      path={ROUTES.SET_PASSWORD}
      component={withTracker(PasswordReset)}
      config={sharedUnauthorizedRouteConfig}
      exact
    />
    <UnauthorizedRoute
      path={ROUTES.CONFIRM_INVITE}
      component={withTracker(pages.InvitationAcceptance)}
      config={sharedUnauthorizedRouteConfig}
      exact
    />
    <UnauthorizedRoute
      path={ROUTES.BEXIO.VERIFY}
      component={withTracker(BexioLogin)}
      config={sharedUnauthorizedRouteConfig}
      exact
    />
    <UnauthorizedRoute
      path={ROUTES.PROJECT.SHARED_REPORT_PUBLIC}
      component={withTracker(SharedReportPublic)}
      config={sharedUnauthorizedRouteConfig}
      exact
    />
    <UnauthorizedRoute
      path={ROUTES.PROJECT.SHARED_REPORT_PRIVATE}
      component={withTracker(SharedReportPrivate)}
      config={sharedUnauthorizedRouteConfig}
      exact
    />
    <Route component={withTracker(pages.NoMatch)} />
  </Switch>
);

export default Routes;
